export default {
    breadcrumb: {
        viewer3dProfile: '3D viewer profile',
        admin: 'Admins',
    },
};
